import { observer } from 'mobx-react-lite'
import { type ITableRowProps, TableRow } from 'shared/ui/TableNew/ui/TableRow/TableRow'
import { type IRowDefault, type ITableProps, type TableStore } from 'shared/ui/TableNew'
import { TableRowChild } from 'shared/ui/TableNew/ui/TableRow/TableRowChild'
import { TableRowMore } from 'shared/ui/TableNew/ui/TableRow/TableRowMore'

type IExpandedTableRowProps<TRow extends IRowDefault> = Omit<
  ITableRowProps<TRow> & {
    store: TableStore<TRow>
    hideExpandColumnsIds?: ITableProps<TRow>['hideExpandColumnsIds']
    onRowChildClick?: ITableProps<TRow>['onRowChildClick']
    getRowChildLink?: ITableProps<TRow>['getRowChildLink']
  },
  'unpinnedColumns' | 'pinnedColumns'
>

export const ExpandedTableRow = observer(
  <TRow extends IRowDefault>({ store, ...props }: IExpandedTableRowProps<TRow>) => {
    const { columnsStore } = store
    const { columns, columnsChild, getUnpinnedColumns, getPinnedColumns } = columnsStore

    return (
      <>
        <TableRow
          {...props}
          pinnedColumns={getPinnedColumns(columns)}
          unpinnedColumns={getUnpinnedColumns(columns)}
        />
        {props.row.expanded && (
          <>
            {props.row.rows?.map((row) => {
              row.setColumnsKeys(props.row.columnsKeys)

              return (
                <TableRowChild
                  key={row.id}
                  {...props}
                  row={row}
                  pinnedColumns={getPinnedColumns(columnsChild)}
                  unpinnedColumns={getUnpinnedColumns(columnsChild)}
                  onRowClick={props.onRowChildClick}
                  getRowLink={props.getRowChildLink}
                />
              )
            })}
            {props.row.isMoreExpand && <TableRowMore row={props.row} />}
          </>
        )}
      </>
    )
  }
)
